import { render, staticRenderFns } from "./product-query.vue?vue&type=template&id=28f80d7b&"
import script from "./product-query.vue?vue&type=script&lang=js&"
export * from "./product-query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports